module.exports = __webpack_public_path__ + "img/1.fda8d096.jpg";